var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "11px",
    viewBox: "0 0 18 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4C43B80B-D982-4DE0-B208-A745C3A945E0-705-000007818A36684E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u05DE\\u05E1\\u05DA-\\u05DC\\u05E7\\u05D5\\u05D7\\u05D5\\u05EA---\\u05E7\\u05D5\\u05E0\\u05E4\\u05D9\\u05D2\\u05D5\\u05E8\\u05E6\\u05D9\\u05D4",
    transform: "translate(-1225.000000, -712.000000)",
    fill: "#4A4A4A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1190.000000, 469.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-/-arrow",
    transform: "translate(44.500000, 248.500000) rotate(-90.000000) translate(-44.500000, -248.500000) translate(39.000000, 239.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.23878935,-2.18491891e-13 L3.27995585,1.09468828 L9.41535525,7.54548156 L10.4565217,8.64016984 L10.347,8.739 L10.4565217,8.83846264 L9.41535525,9.93315092 L3.27995585,16.3839442 L2.23878935,17.4786325 L-8.70414851e-14,15.4422591 L1.04116649,14.3475708 L6.375,8.739 L1.04116649,3.13106165 L-8.70414851e-14,2.03637337 L2.23878935,-2.18491891e-13 Z",
    transform: "translate(5.228261, 8.739316) scale(-1, 1) translate(-5.228261, -8.739316) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.6125f528fbbd1e38399914c8f934ae8b.svg";
export { ForwardRef as ReactComponent };